jQuery(document).ready(function ($) {

	// Site Wrapper Padding On Header Height
	function announcebar() {
		var headerHeight = $('.header').outerHeight();
    		$('.site-wrapper').css("padding-top", headerHeight);
	}
	announcebar();
	$(window).on('resize orientationchange', function () {
		announcebar();
	});

	// On Scroll Add-Remove Class Menu Js
	$(window).scroll(function(){
		if ($(window).scrollTop() >= 50) {
			$('header').addClass('fixed');
		}
		else {
			$('header').removeClass('fixed');
		}
	});

	// Toggle Menu Js (For Mobile Screen)
	function main_menu() {
		var headerHeight = $('header').outerHeight();
        if (jQuery(window).width() < 991) {
    		$('.header-content .header-center').css("top", headerHeight);
    	}
    }
	main_menu();
	$(window).on('resize orientationchange', function () {
		main_menu();
	});

	// Main Menu Js (For Mobile Screen)
	$('.navbar-toggler').click(function(){
		$(this).toggleClass('active');
		$('.header-center').toggleClass('open'); 
		$('body').toggleClass('overlay-hidden');
	});

    // Search Bar
    document.querySelector('.magic-icon-search').addEventListener('click', (e) => {
        e.target.classList.toggle('close');
    });
    $('.search-link').click(function(e){
        e.preventDefault() 
        $(this).toggleClass('active');
		$('.search-bar').toggleClass('open');
	});

	// Our Features Carousel (HOME PAGE)
	// function our_features_carousel() {
	// 	const our_features_carousel = new Swiper('.our-features-carousel', {
	// 		spaceBetween: 30,
	// 		slidesPerView: 4,
	// 		slidesToScroll: 1,
	// 		pagination: {
	// 			el: ".swiper-pagination",
	// 			clickable: true,
	// 		},
	// 		breakpoints: {
	// 			1025: {
	// 				slidesPerView: 4,
	// 				spaceBetween: 20,
	// 			},
	// 			800: {
	// 				slidesPerView: 3,
	// 				spaceBetween: 10,
	// 			},
	// 			640: {
	// 				slidesPerView: 2,
	// 				spaceBetween: 10,
	// 			},
	// 			480: {
	// 				slidesPerView: 1.5,
	// 				spaceBetween: 10,
	// 			},
	// 			320: {
	// 				slidesPerView: 1,
	// 				spaceBetween: 10,
	// 			},
	// 		},
	// 	});
	// }
	// our_features_carousel();
	// $(window).on('resize orientationchange', function () {
	// 	our_features_carousel();
	// });

	// Our Features Carousel (HOME PAGE)
	const user_word_carousel = new Swiper('.user-word-carousel', {
		loop: true,
		grabCursor: true,
		spaceBetween: 30,
		slidesPerView: 2.5,
		slidesToScroll: 1,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		spaceBetween: 30,
		centeredSlides: false,
		breakpoints: {
			1920: {
				slidesPerView: 2.4,
			},
			1200: {
				slidesPerView: 2.2,
			},
			991: {
				slidesPerView: 1.4,
			},
			480: {
				slidesPerView: 1.1,
			},
			320: {
				slidesPerView: 1,
			}
		},
	});

	// Pricing Carousel (Home Page)
	const breakpoint = window.matchMedia('(min-width:1280px)');
	let pricing_carousel;
	const pricing_carousel_breakpointChecker = function () {
		if (breakpoint.matches === true) {
			if (pricing_carousel !== undefined) pricing_carousel.destroy(true, true);
			return;
		} else if (breakpoint.matches === false) {
			return pricing_enableSwiper();
		}
	};
	const pricing_enableSwiper = function () {
		pricing_carousel = new Swiper('.pricing-carousel', {
			spaceBetween: 0,
			slidesPerView: 5,
			slidesToScroll: 1,
			grabCursor: true,
			breakpoints: {
				991: {
					slidesPerView: 3,
				},
				768: {
					slidesPerView: 2.5,
				},
				640: {
					slidesPerView: 2,
				},
				320: {
					slidesPerView: 1,
				},
			}
		});
	};
	breakpoint.addListener(pricing_carousel_breakpointChecker);
	pricing_carousel_breakpointChecker();

	// Footer Carousel
	const footer_carousel = new Swiper('.footer-carousel', {
		slidesPerView: 1,
		slidesToScroll: 1,
		spaceBetween: 30,
		autoplay: {
			delay: 5000, // Slides change every 5 seconds
			disableOnInteraction: false,
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			1440: {
				slidesPerView: 4,
			},
            1100: {
  				slidesPerView: 3.5,
  			},
			991: {
				slidesPerView: 3,
			},
			767: {
				slidesPerView: 2.3,
			},
			640: {
				slidesPerView: 2,
			},
			480: {
				slidesPerView: 1.5,
			},
			380: {
				slidesPerView: 1.3,
			},
			0: {
				slidesPerView: 1,
			}
		},
	});

  $('.animation-left').marquee({
				direction: 'left',
				duration: 50000,
				gap: 0,
				delayBeforeStart: 0,
				duplicated: true,
				startVisible: true
			});
			$('.animation-right').marquee({
				direction: 'right',
				duration: 50000,
				gap: 0,
				delayBeforeStart: 0,
				duplicated: true,
				startVisible: true
			});
  
});


var buttonPlus  = $(".btn-plus");
var buttonMinus = $(".btn-minus");

var incrementPlus = buttonPlus.click(function() {
  var $n = $(this)
  .parent(".qty-box")
  .find(".input-qty");
  $n.val(Number($n.val())+1 );
});

var incrementMinus = buttonMinus.click(function() {
  var $n = $(this)
  .parent(".qty-box")
  .find(".input-qty");
  var amount = Number($n.val());
  if (amount > 0) {
    $n.val(amount-1);
  }
  
});

// Conditional Shipping Rates Page Js
$(document).ready(function () {
    // Conditional Shipping Rates Tab Js
    $('.shipping-rates-tabs ul li a').click(function (e) {
        e.preventDefault();
        if ($(window).width() > 767) {
            $('.shipping-rates-tabs ul li a').removeClass('active');
            $(this).addClass('active');
        }
        var tagid = $(this).attr('data-tag');
        $('.shipping-rates-tab-content .tab-content').removeClass('current');
        $('.shipping-rates-tab-content .tab-content#'+tagid).addClass('current');
    });
    
    if ($(window).width() < 768) {
        $('.shipping-rates-tabs .active-tab h3').click(function (e) {
            e.preventDefault();
            $('.shipping-rates-tabs .active-tab h3').removeClass('active');
            $('.shipping-rates-tabs ul').slideUp();
            if (!$(this).parent('.active-tab').next().is(':visible')) {
                $(this).parent('.active-tab').next().slideDown();
                $(this).addClass('active');
            }
            $(".shipping-rates-tabs .active-tab h3").html($(this).html());
        });
        $(".shipping-rates-tabs ul li a").click(function(e){
            e.preventDefault();
            $('.shipping-rates-tabs ul li a').removeClass('active');
            $(this).addClass('active');
            $('.shipping-rates-tabs .active-tab h3').toggleClass('active');
            $('.shipping-rates-tabs ul').slideUp();
            $(".shipping-rates-tabs .active-tab h3").html($(this).html());
        });
    }
});

$('body').on('click', '.learn-more-button.add_to_Cart a',function(e){
  e.preventDefault();
  var item_id =  parseInt($(this).next(".product_value").attr('value')), prop_ID;
  var data = {
    quantity: 1,
    id: item_id,
    properties: {
      '_test': 'YES'
    }
  }
  $.getJSON('/cart.js').then(function(cart) {
    if (cart.item_count != 0){
        var found_prop = false;
        $(cart.items).each(function(idx, item){ 
          if (Object.keys(item.properties).length > 0){
            $(item.properties).each(function(i, prop){
              if (prop.hasOwnProperty('_test')){
                  found_prop = true;
                  theme.cart.changeItem(item.id, 0).then(function(cart) {theme.cart.addItemFromForm(data).then(function(cart){
                      window.location.href = '/cart';
                  });
                });
              } 
            });
           }
            if (cart.items.length == (idx+1)){
              if (!found_prop){
                theme.cart.addItemFromForm(data).then(function(cart){
                    window.location.href = '/cart';
                });  
              }
            }
        });
    } else {
      theme.cart.addItemFromForm(data).then(function(cart){
          window.location.href = '/cart';
      });
    }
  });   
});

$("body").ready(function(){
var l = $(".cart__checkout-wrapper").children().length;
if(l==3){
    $(".cart__checkout-wrapper").addClass('hello');
}else{
  $(".cart__checkout-wrapper").removeClass('hello');
}
});  

var cart_note = $(".description").html();
console.log(cart_note);
$(".cart_note").append(cart_note);